import { Component } from 'react';

import { RouteProps } from '../../types/route-types';
import styles from './static-page.component.module.scss';

export default class StaticPageComponent extends Component<RouteProps> {
    public htmlString = null;


    constructor(props: RouteProps) {
        super(props);
    }

    render() {
        return <div className="container-fluid">
            <div className={`row mt-5 mb-5 ${styles['static-content']}`}>
                <div className="col-sm-12 col-md-1"></div>
                <div className="col-sm-12 col-md-10">
                    <div dangerouslySetInnerHTML={{ __html: this.props.markdownHtml }}></div>
                </div>
                <div className="col-sm-12 col-md-1"></div>
            </div>
        </div>
    }
}